<template>
    <div class="row mt-4">
        <div class="col-md-6">
            <div class="card card-stats">
                <div class="card-body">
                    <div class="card-title text-center">
                        По платежным системам
                    </div>

                    <div class="card-subtitle">
                        <div class="row">
                            <div class="col-12">
                                <canvas id="payment-system-stats" height="100px"></canvas>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>


    </div>
</template>

<script>
    export default {
        name: "AnalyticsPaymentSystemGroup",
        data() {
            return {
                chart: null
            }
        },
        computed: {
            filterType() {
                return this.$store.state.filterType;
            },
            paymentType() {
                return this.$store.state.filterPaymentType;
            },
            dateFrom () {
                return this.$store.state.filterDateFrom
            },
            dateTo() {
                return this.$store.state.filterDateTo
            },
            merchantId() {
                return this.$store.state.merchantId;
            },
            admin() {
                return this.$store.state.admin;
            }
        },
        watch: {
            filterType() {
                if (this.dateFrom != null)
                    this.apiCall(this.dateFrom, this.dateTo);
            },
            paymentType() {
                this.apiCall(this.dateFrom, this.dateTo);
            },
            merchantId() {
                this.apiCall(this.dateFrom, this.dateTo);
            }
        },
        mounted() {
            let ctx = document.getElementById("payment-system-stats");
            this.chart = new Chart(ctx, {
                type: 'horizontalBar',
                data: {
                    datasets: [{
                        backgroundColor: [
                            '#027662',
                            '#ef3124'
                        ],
                        borderWidth: 0
                    }]
                },
                options: {
                    legend: {
                        display: false
                    },
                    scales: {
                        xAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }],
                        xAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    }
                }
            });
            this.apiCall(this.dateFrom);
        },
        methods: {
            apiCall(dateFrom, dateTo) {
                this.chart.data.labels = [];
                this.chart.data.datasets[0].data = [];
                this.$store.commit('setLoading');
                let params = {
                    'payment-type': this.paymentType,
                    'date-from': dateFrom,
                    'date-to': dateTo,
                    'bank-id': this.bankId,
                    'mps-id': this.mpsId,
                };
                if (this.merchantId) {
                    params['merchant-id'] = this.merchantId;
                }
                axios.get('/admin/analytics/turnover-payment-system', {
                    params: params,
                })
                    .then(response => {
                        let payments = response.data.data;
                        for (const payment of payments) {
                            this.chart.data.labels.push(payment.name);
                            this.chart.data.datasets.forEach((dataset) => {
                                dataset.data.push(parseInt(payment.amount));
                            });
                            this.chart.update();
                        }
                    })
                    .then(() => {
                        this.$store.commit('unsetLoading');
                    });
            }
        },
    }
</script>

<style scoped>

</style>
